<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Search Form
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="px-2 pt-4 pb-0">

                                        <v-col lg="3" md="3" cols="12">
                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="From Date"
                                                density="compact"
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                prepend-icon=""
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="from_date.value.value"
                                                :error-messages="from_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            />
                                        </v-col>

                                        <v-col lg="3" md="3" cols="12">
                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="To Date"
                                                density="compact"
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                prepend-icon=""
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="to_date.value.value"
                                                :error-messages="to_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            />
                                        </v-col>

                                        <v-col lg="2" md="2" cols="12">
                                            <v-btn
                                                class="bg-brand w-15"
                                                type="submit"
                                                ref="searchButton"
                                            >
                                                Search
                                            </v-btn>
                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>

                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>


        <v-container fluid style="margin-top:-20px;">
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>

                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Raw Material Inventory List
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>

                                <v-row class="py-2">

                                    <v-col md="4" cols="12">
                                        <v-text-field
                                            v-model="search"
                                            append-inner-icon="mdi-magnify"
                                            label="Search"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            class="pl-2"
                                            clearable
                                        />
                                    </v-col>

                                    <v-col md="5" cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group
                                                variant="outlined"
                                                density="compact"
                                                size="x-small"
                                                divided
                                            >
                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="success"
                                                @click="exportToCSV"
                                                >CSV</v-btn
                                                >
                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                >EXCEL</v-btn
                                                >
                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="red"
                                                @click="exportToPDF"
                                                >PDF</v-btn
                                                >
                                            </v-btn-group>
                                        </div>
                                    </v-col>

                                </v-row>

                                <v-row class="pt-0">
                                    <v-col cols="12">

                                        <div class="scrollable-table-wrapper">

                                            <v-data-table
                                                :headers="headers"
                                                :items="getSchema"
                                                :loading="loading"
                                                v-model:items-per-page="itemsPerPage"
                                                :search="search"
                                                :hover="true"
                                                density="compact"
                                                class="responsive-table"
                                            >

                                                <template v-slot:item.index="{ index }">
                                                    {{ ++index }}
                                                </template>

                                                <template v-slot:item.sale_order="{ item }">
                                                    {{ item.sale_order_master?.code }}
                                                </template>

                                                <template v-slot:item.production_requisition="{ item }">
                                                    {{ item.orderable?.code }}
                                                </template>

                                                <template v-slot:item.product="{ item }">
                                                    {{ item.product?.name }}
                                                </template>

                                                <template v-slot:item.quantity="{ item }">
                                                    {{ Number(item.quantity).toLocaleString() }}
                                                </template>

                                                <template v-slot:item.purchase_unit_price="{ item }">
                                                    {{ Number(item.purchase_unit_price).toLocaleString() }}
                                                </template>

                                                <template v-slot:item.created_by="{ item }">
                                                    {{ item.created_by?.full_name }}
                                                </template>

                                                <template v-slot:item.created_at="{ item }">
                                                    {{ formatDateView(item.created_at) }}
                                                </template>

                                            </v-data-table>

                                        </div>

                                    </v-col>
                                </v-row>

                            </v-expansion-panel-text>

                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script setup>

import { ref, computed, onMounted, nextTick } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";

import formattedDate from "@/plugins/dateFormatter";
import { formatDateView } from "@/plugins/helpers";

const store = useStore();

const itemsPerPage = ref(10);
const panel = ref([0]);
const search = ref("");
const loading = ref(false);

const searchButton = ref(null);

const headers = [

    { title:"#SL", align:"center", key:"index", width:"15px", sortable:false },

    { title:"Inventory Code", key:"code", align:"center", width:"140px" },

    { title:"Sale Order", key:"sale_order", align:"center", width:"140px" },

    { title:"Production Req.", key:"production_requisition", align:"center", width:"150px" },

    { title:"Product", key:"product", align:"center", width:"150px" },

    { title:"Batch No", key:"batch_no", align:"center", width:"150px" },

    { title:"Quantity", key:"quantity", align:"center", width:"100px" },

    { title:"Purchase Price", key:"purchase_unit_price", align:"center", width:"130px" },

    { title:"Created By", key:"created_by", align:"center", width:"150px" },

    { title:"Created Date", key:"created_at", align:"center", width:"150px" }

];

const getSchema = computed(() => store.getters.productionRawMaterialInventoryList);

const { handleSubmit } = useForm({
    validationSchema: yup.object({})
});

const from_date = useField("from_date");
const to_date = useField("to_date");

const submit = handleSubmit((values) => {

    loading.value = true;

    values.from_date = formattedDate(from_date.value.value);
    values.to_date = formattedDate(to_date.value.value);

    store
        .dispatch("productionRawMaterialInventoryList", values)
        .then(() => {
            loading.value = false;
        })
        .catch((error) => {
            loading.value = false;
            toast.error(error.response?.data?.message);
        });

});

function exportToPDF() {

    let serial = 1;

    const columns = [
        "#SL",
        "Inventory Code",
        "Product",
        "Batch",
        "Quantity",
        "Purchase Price"
    ];

    const rows = getSchema.value.map((item) => [
        serial++,
        item.code,
        item.product?.name,
        item.batch_no,
        item.quantity,
        item.purchase_unit_price
    ]);

    window.$exportTableToPDF(
        columns,
        rows,
        "Raw Material Inventory",
        "raw_material_inventory_" + window.$fileDate(),
        "landscape"
    );
}

function exportToExcel() {

    let data = [
        ["#SL","Inventory Code","Product","Batch","Quantity","Purchase Price"]
    ];

    let serial = 1;

    getSchema.value.forEach((item) => {

        data.push([
            serial++,
            item.code,
            item.product?.name,
            item.batch_no,
            item.quantity,
            item.purchase_unit_price
        ]);

    });

    window.$exportTableToExcel(
        data,
        "raw_material_inventory_" + window.$fileDate()
    );
}

function exportToCSV() {

    let data = [
        ["#SL","Inventory Code","Product","Batch","Quantity","Purchase Price"]
    ];

    let serial = 1;

    getSchema.value.forEach((item) => {

        data.push([
            serial++,
            item.code,
            item.product?.name,
            item.batch_no,
            item.quantity,
            item.purchase_unit_price
        ]);

    });

    window.$exportTableToCSV(
        data,
        "raw_material_inventory_" + window.$fileDate()
    );
}

onMounted(() => {

    const today = new Date();
    const oneMonthBack = new Date();

    oneMonthBack.setMonth(today.getMonth() - 1);

    from_date.value.value = oneMonthBack;
    to_date.value.value = today;

    nextTick(() => {
        searchButton.value?.$el?.click();
    });

});

</script>


<style scoped>

.scrollable-table-wrapper {
    overflow-x:auto;
    max-width:100%;
}

.v-data-table {
    min-width:1200px;
    table-layout:fixed;
}

.responsive-table th,
.responsive-table td {
    white-space:nowrap;
    text-overflow:ellipsis;
    overflow:hidden;
}

</style>